import React from "react";
import { motion } from "framer-motion";
import ProgressBar from "../components/ProgressBar";

import girlImg from "../images/step5_girl.png";

const Step5 = () => {
  const student = JSON.parse(localStorage.getItem("student"));

  const gotoNext = async () => {
    // Mengambil student_id yang benar (berdasarkan skrip sebelumnya, kunci adalah student_id)
    const studentId = student?.student_id; 

    if (!studentId) {
      alert("Student data not found. Please login again.");
      window.location.href = "/login";
      return;
    }

    try {
      await fetch(
        `http://localhost:3000/api/student-demography/${studentId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            current_step: "6", // <-- TRACKING STEP
          }),
        }
      );
    } catch (err) {
      console.error("Error updating current_step:", err);
    }

    window.location.href = "/step6";
  };

  return (
    <div className="relative min-h-screen flex flex-col items-center bg-gradient-to-b from-blue-900 via-blue-700 to-blue-400 text-white overflow-hidden">
      {/* Progress Bar */}
      <div className="w-full max-w-lg mt-6 z-20">
        <ProgressBar step={5} />
      </div>

      {/* GIRL + TEXT CONTAINER - Menggunakan flexbox untuk sejajar */}
      <div className="relative w-full max-w-5xl flex flex-col md:flex-row justify-center items-center gap-4 md:gap-1 mt-6 md:mt-12 z-10 px-4">
        
        {/* Girl Image */}
        <img
          src={girlImg}
          className="relative z-20 w-64 md:w-[450px] drop-shadow-xl" 
          alt="girl"
        />

        {/* Text Container - Disamping gambar */}
        <motion.div
            className="flex-1 max-w-sm bg-white/20 p-4 md:p-6 rounded-lg backdrop-blur-sm shadow-xl text-center md:text-left"
            initial={{ opacity: 0, x: -20 }} // Animasi dari kiri (jika di samping)
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
        >
            <p className="text-xl md:text-2xl font-bold text-yellow-300 leading-tight">
                Thanks for sharing!
            </p>
            <p className="text-base md:text-lg text-white mt-2 leading-snug">
                We know you a little better now! 
                <span className="text-red-300"> 💥</span>
            </p>
        </motion.div>
      </div>

      {/* NEXT Button */}
      <motion.button
        whileHover={{ scale: 1.04 }}
        whileTap={{ scale: 0.97 }}
        onClick={gotoNext}
        className="mt-16 md:mt-24 bg-yellow-400 text-blue-900 font-bold px-10 py-3 rounded-xl shadow-lg border-4 border-yellow-300 text-base md:text-lg"
      >
        NEXT →
      </motion.button>

      {/* Footer */}
      <p className="absolute bottom-6 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>
    </div>
  );
};

export default Step5;